import React from 'react';
type ButtonVariant = 'default' | 'outline' | 'secondary' | 'destructive' | 'success' | 'ghost';
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  children: React.ReactNode;
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  variant = 'default',
  size = 'md',
  className = '',
  children,
  isLoading = false,
  leftIcon,
  rightIcon,
  ...props
}: ButtonProps) {
  const variantStyles: Record<ButtonVariant, string> = {
    default: 'bg-blue-600 hover:bg-blue-700 text-white border-transparent shadow-sm',
    outline: 'bg-transparent hover:bg-gray-700 text-gray-200 border-gray-600',
    secondary: 'bg-gray-700 hover:bg-gray-600 text-gray-200 border-gray-600 shadow-sm',
    destructive: 'bg-red-600 hover:bg-red-700 text-white border-transparent shadow-sm',
    success: 'bg-green-600 hover:bg-green-700 text-white border-transparent shadow-sm',
    ghost: 'bg-transparent hover:bg-gray-700 text-gray-300 border-transparent'
  };
  const sizeStyles: Record<ButtonSize, string> = {
    xs: 'text-xs px-2 py-1 rounded',
    sm: 'text-xs px-2.5 py-1.5 rounded-md',
    md: 'text-sm px-4 py-2 rounded-md',
    lg: 'text-base px-5 py-2.5 rounded-md'
  };
  return <button className={`inline-flex items-center justify-center font-medium border transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-blue-500 disabled:opacity-60 disabled:pointer-events-none ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-767">
      {isLoading && <div className="mr-2 h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin" data-id="element-768"></div>}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-769">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-770">{rightIcon}</span>}
    </button>;
}